import React, { PropsWithChildren } from "react";
import { RenderWhen } from "../../../../../../components";

export interface TiCardAdditionalInformationLayoutProps {
  closeDetails: () => void;
  seeRelatedSamplesRoute?: string;
}

const TiCardAdditionalInformationLayout = ({
  closeDetails,
  seeRelatedSamplesRoute,
  children
}: PropsWithChildren<TiCardAdditionalInformationLayoutProps>) => (
  <div className={"ticard-content__additional_information"}>
    <div className={"ticard-content__additional_information-header"}>
      <p className={"header__hide-info"} onClick={closeDetails}>
        Hide Additional Information
      </p>
      <RenderWhen condition={!!seeRelatedSamplesRoute}>
        <div className={"header__elements-divider"} />
        <a
          className={"header__show-samples"}
          href={seeRelatedSamplesRoute}
          target="_blank"
          rel="noreferrer"
        >
          See Related Samples
        </a>
      </RenderWhen>
    </div>
    {children}
  </div>
);

export default TiCardAdditionalInformationLayout;
